<template>
    <el-dialog title="Pilih Material" :visible.sync="internalVisible" width="60%" :before-close="handleClose"
        :close-on-click-modal="false">
        <div>
            <div class="d-flex justify-content-between mb-3">
                <select class="form-control rounded-0 select-custom-size" v-model="table.params.per_page">
                    <option value="10">Tampilkan 10</option>
                    <option value="25">Tampilkan 25</option>
                    <option value="50">Tampilkan 50</option>
                    <option value="100">Tampilkan 100</option>
                    <option value="200">Tampilkan 200</option>
                </select>
                <div>
                    <button class="btn bg-yellow text-white rounded-0 btn-sm" @click="handleClearFilter">Clear Filter</button>
                    <button class="btn btn-danger rounded-0 btn-sm" @click="handleUncheckAll">Uncheck All</button>
                    <button class="btn btn-primary rounded-0 btn-sm" @click="handleSubmitMaterial">Add</button>
                </div>
            </div>
            <div class="table-responsive mb-5 table-wrapper">
                <table class="table table-hover" v-if="!onLoadMaterial">
                    <thead>
                        <tr>
                            <th scope="col" class="font-weight-bold">No</th>
                            <th scope="col" class="font-weight-bold">
                                <div class="form-group form-check text-center mt-1">
                                    <input type="checkbox" v-model="checkAll" @change="toggleCheckAll"
                                        class="form-check-input custom-checkbox-lg" :id="`check-all`">
                                </div>
                            </th>
                            <th scope="col" class="font-weight-bold px-5">MATERIAL</th>
                            <th scope="col" class="font-weight-bold">SUBJECT</th>
                            <th scope="col" class="font-weight-bold">ITEM DESCRIPTION</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <th></th>
                            <th></th>
                            <th class="py-1 align-middle"><input type="text" class="form-control rounded-0 input-custom-size"
                                    v-model="table.params.material_number" @change="handleSearch"></th>
                            <td class="py-1 align-middle"><input type="text" class="form-control rounded-0 input-custom-size"
                                    v-model="table.params.subject" @change="handleSearch"></td>
                            <td class="py-1 align-middle"><input type="text" class="form-control rounded-0 input-custom-size"
                                    v-model="table.params.item_name" @change="handleSearch"></td>
                        </tr>
                        <tr v-if="table.data.length > 0" v-for="(item, index) in table.data" :key="index">
                            <th scope="row" class="py-1 align-middle text-center">{{ ((table.pagination.current_page -
                                1) * table.pagination.per_page) + (index + 1) }}</th>
                            <td class="py-1 align-middle">
                                <div class="form-group form-check">
                                    <input type="checkbox" class="form-check-input custom-checkbox-lg mt-1"
                                        :id="`check-${item.material_number}`" v-model="checkedItems"
                                        :value="item.material_number" @change="handleCheckPerItem"
                                        :disabled="internalMatNumSelected >= 150 && !checkedItems.includes(item.material_number)"  
                                    >
                                </div>
                            </td>
                            <td class="py-1 align-middle">{{ item?.material_number }}</td>
                            <td class="py-1 align-middle text-left">{{ item?.subject }}</td>
                            <td class="py-1 align-middle text-left">{{ item?.item_name }}</td>
                        </tr>
                        <tr v-if="table.data.length == 0">
                            <td colspan="5" class="align-middle text-center">No Data</td>
                        </tr>
                    </tbody>
                </table>

                <skeleton-loading v-else />
            </div>
            <div class="d-flex justify-content-center">
                <span class="float-left">
                    <base-pagination :page-count="table.pagination.last_page" v-model="table.pagination.current_page"
                        @click.native="handlePaginate(table.pagination.current_page)" size="sm"></base-pagination>
                </span>
            </div>
            <div class="d-flex justify-content-center">
                <span>
                    {{ tt('page_info', {
                        size: (table.pagination.current_page - 1) * table.pagination.per_page +
                            table.data.length, total: table.pagination.total
                    }) }}
                </span>
            </div>
        </div>
    </el-dialog>
</template>

<script>
import Api from '@/helpers/api';
import materialRequestList from '@/services/material/materialRequestList.service';

export default {
    name: 'ModalTableMaterial',
    data() {
        return {
            table: {
                params: {
                    type: this.$route.query.type ? this.$route.query.type : '',
                    mcr_number: this.$route.query.mcr_number ? this.$route.query.mcr_number : '',
                    subject: this.$route.query.subject ? this.$route.query.subject : '',
                    material_number: this.$route.query.material_number ? this.$route.query.material_number : '',
                    item_name: this.$route.query.item_name ? this.$route.query.item_name : '',
                    created_start: this.$route.query.created_start,
                    created_end: this.$route.query.created_end,
                    company: this.$route.query.company ? this.$route.query.company : '',
                    mtype_code: 'ZSP',
                    page: 1,
                    per_page: 10
                },
                total: 0,
                data: [],
                pagination: {
                    current_page: 0,
                    last_page: 0,
                    per_page: 0,
                    total: 0,
                },
            },
            checkAll: false,
            checkedItems: [],
            onLoadMaterial: false
        }
    },
    props: {
        visibleModalTableMaterial: {
            type: Boolean,
            required: false
        },
        plant: {
            required: true
        },
        materialNumbers: {
            require: true
        },
        selectedMaterial: {
            type: Number,
            require: true
        },
    },
    computed: {
        internalVisible: {
            get() {
                return this.visibleModalTableMaterial;
            },
            set(val) {
                this.$emit('update:visibleModalTableMaterial', val)
            }
        },
        internalMultipleMatNum: {
            get() {
                return this.materialNumbers
            },
            set(val) {
                this.$emit('update:materialNumbers', val)
            }
        },
        internalMatNumSelected: {
            get() {
                return this.selectedMaterial
            },
            set(val) {
                this.$emit('update:selectedMaterial', val)
            }
        },
    },
    mounted() {
        this.fetchData()
    },
    methods: {
        handleClose() {
            this.internalVisible = false;
        },
        submit() {
            this.$emit('submit-filter');
        },
        toggleCheckAll() {
            if (this.checkAll) {
                const current_product = this.table.data.map(item => item.material_number)
                const checked_product = this.checkedItems
                const available_item  = (150 - checked_product.length)
                const slected_poduct  = current_product.reduce((acc, item) => {
                    if (acc.length < available_item && !checked_product.includes(item)) acc.push(item)
                    return acc
                }, [])

                this.checkedItems = [... checked_product, ... slected_poduct]
            } else {
                const current_product = this.table.data.map(item => item.material_number)
                const checked_product = this.checkedItems

                this.checkedItems     = checked_product.filter(item => !current_product.includes(item))
            }
        },
        handleCheckPerItem() {
            const current_product   = this.table.data.map(item => item.material_number)
            const checked_product   = this.checkedItems
            const allCheckedInPage  = current_product.every(item => checked_product.includes(item))
            this.checkAll           = allCheckedInPage
        },
        fetchData() {
            const params        = this.table.params
            params.plant        = this.plant
            this.onLoadMaterial = true
    
            Api(this, materialRequestList.get_list(this.table.params))
                .onSuccess(response => {
                    this.table.total    = response.data.data.total;
                    this.table.data     = response.data.data.data;

                    this.table.pagination = {
                        current_page: response.data.data.current_page,
                        last_page: response.data.data.last_page,
                        per_page: response.data.data.per_page,
                        total: response.data.data.total,
                    }
                }).onError(error => {
                    if (error.response.status == 404) {
                        this.table.data = [];
                        this.table.total = 0;
                    }
                })
                .onFinish(() => {
                    this.onLoadMaterial = false
                })
                .call()
        },
        handlePaginate(page) {
            this.table.params.page = page
            this.fetchData()
        },
        handleSearch() {
            this.table.params.page = 1
            this.fetchData()
        },
        handleClearFilter() {
            this.table.params.material_number = ''
            this.table.params.subject = ''
            this.table.params.item_name = ''

            this.fetchData()
        },
        handleSubmitMaterial() {
            const insertMaterial = this.checkedItems.join('\n')
            this.internalMultipleMatNum = insertMaterial
            this.handleClose()
        },
        handleUncheckAll() {
            this.checkAll = false
            this.checkedItems = []
            this.internalMultipleMatNum = ''
        }
    },
    watch: {
        'table.params.per_page': function () {
            this.table.params.page = 1
            this.fetchData()
        },
        'plant': function () {
            this.table.params.page = 1
            this.checkedItems = []
            this.checkAll = false
            
            this.handleSubmitMaterial()
            this.fetchData()
        },
        'table.data': function () {
            this.handleCheckPerItem()
        },
        'internalMultipleMatNum': function () {
            const insertMaterial = this.materialNumbers
                .split(/[\n,]+/)
                .map((val) => val.replace(/[" ,]/g, "").trim())
                .filter((val) => val !== "");

            this.checkedItems = insertMaterial
            this.handleCheckPerItem()
        },
        'checkedItems': function () {
            this.internalMatNumSelected = this.checkedItems.length
        }
    }
};
</script>

<style scoped>
.table-wrapper {
    max-height: 550px;
    overflow-y: auto;
    border: 1px solid #dee2e6;
}

/* Sticky header */
.table thead th {
    position: sticky;
    top: 0;
    background-color: #fff;
    /* or use Bootstrap var: #f8f9fa */
    z-index: 1;
    border-bottom: 2px solid #dee2e6;
}

input.form-check-input.custom-checkbox-lg {
    cursor: pointer;
}

.input-custom-size {
    height: 32px;
    /* atur sesuai kebutuhan */
    font-size: 0.85rem;
    /* padding: 0px 0px!important; */
}
.select-custom-size {
    height: 32px;
    /* atur sesuai kebutuhan */
    font-size: 12px;
    padding: 0px 5px 0px 5px!important;
    width: 135px;
    cursor: pointer;
}
</style>